export default __webpack_public_path__ + "static/media/img_papaground05.9347fe71.jpg";